<dx-popup
  [showTitle]="true"
  title="Impression de la facture"
  [(visible)]="displayDialog"
  [width]="900"
  [height]="'auto'"
  [maxHeight]="800"
  [resizeEnabled]="true"
  [showCloseButton]="true"
  (onHidden)="closeDialog()"
>
  <div class="settings-facture">
    <div>Commentaire :</div>
    <div class="dialog-line">
      <div>
        <dx-text-area
          [(ngModel)]="comment"
          placeholder="Commentaire"
        ></dx-text-area>
      </div>
    </div>
  </div>

  <!-- le div intermédiaire reçoit le padding de `.dialog-line > *`, que le thème DevExtreme annule sur un dx-check-box enfant direct -->
  <div class="dialog-line">
    <div>
      <dx-check-box [(ngModel)]="detailsOption" text="Impression avec détails"></dx-check-box>
    </div>
  </div>
  <div class="dialog-line">
    <div>
      <dx-check-box [(ngModel)]="logoOption" text="Impression avec logo"></dx-check-box>
    </div>
  </div>
  <div class="dialog-line">
    <div>
      <dx-check-box [(ngModel)]="factureXOption" text="Factur-X"></dx-check-box>
    </div>
  </div>
  <div class="custom-button-container-right">
    <yo-button label="Imprimer"
               iconClass="fas fa-print"
               [theme]="ButtonThemeEnum.DEFAULT"
               (onClick)="print()">
    </yo-button>
    <yo-button [theme]="ButtonThemeEnum.CANCEL"
               iconClass="fas fa-times"
               (onClick)="closeDialog()">
    </yo-button>
  </div>
</dx-popup>
